import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_438 implements Validator {

    public static id = 'CTRL_438';
    private message = 'error.ctr_438';


    public LOG: LogService = new LogService(CTRL_438);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_438.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const datePublicationNameWithStepId = map.get(ctrl.value.rgCtrls.datePublication);
                
                const datePublicationCtrl = form.controls[datePublicationNameWithStepId];
                if (datePublicationCtrl.value !== 'yyyy-MM-dd' && datePublicationCtrl.value !== '' && datePublicationCtrl.value > formatDate(new Date(), 'yyyy-MM-dd', 'en')) {
                            // placer le message d'erreur
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                        } else {
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                        }
            }
        }
    }
}
